import { DocumentPreview } from './DocumentPreview';
import type { TFICDocument } from '../types/Document';

type CreditCardPreviewProps = {
    document: TFICDocument;
};

export function CreditCardPreview({ document }: CreditCardPreviewProps) {
    return (
        <div className="w-full flex justify-center items-start overflow-y-auto p-4 h-full max-h-[85vh]">
            <DocumentPreview document={document} />
        </div>
    );
}
